import { render, staticRenderFns } from "./sqxzjcgszlnew.vue?vue&type=template&id=2ff5da33&scoped=true&"
import script from "./sqxzjcgszlnew.vue?vue&type=script&lang=js&"
export * from "./sqxzjcgszlnew.vue?vue&type=script&lang=js&"
import style0 from "./sqxzjcgszlnew.vue?vue&type=style&index=0&id=2ff5da33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff5da33",
  null
  
)

export default component.exports